import useAuth from "hooks/useAuth";
import { useTranslation } from "react-i18next";
import { DashboardData } from "services/dashboardService";
import { toCurrency, toPercent } from "utils/format";
import { cn } from "utils/styles";

type Props = {
  variant?: "primary" | "secondary";
  data: DashboardData;
};

export const RoiCard = ({
  variant = "primary",
  data,
}: Props) => {
  const { t, i18n } = useTranslation();
  const { selectedProvider } = useAuth();

  return (
    <div
      className={cn(
        "rounded-2xl flex flex-col items-center justify-center  min-h-[9rem] laptop:flex-1",
        variant === "primary"
          ? "bg-primaryMultiply/70 px-8 desktop:px-4"
          : "border border-white/30 py-2 px-2 desktop-lg:px-4"
      )}
    >
      <div className="flex items-center gap-2 text-center mb-2">
        <img
          className={cn(variant === "primary" ? "" : "h-3.5")}
          src="/icons/campaigns/cart.svg"
          alt=""
        />
        <p className={cn(variant === "primary" ? "" : "text-xs")}>
          {t("dashboard.cards.roi")} | {t("dashboard.cards.mrr")}
        </p>
      </div>
      <div className="font-input flex items-center gap-2">
        <p className="text-secondary text-sm">{t("dashboard.cards.mrr")}</p>
        <p
          className={cn(
            "font-bold text-center",
            variant === "primary" ? "text-2xl" : "text-xl"
          )}
        >
          {toCurrency(data.financial.mrr, i18n.language, selectedProvider.currency)}
        </p>
      </div>
      <div className="font-input flex items-center gap-2">
        <p className="text-secondary text-sm">{t("dashboard.cards.roi")}</p>
        <p
          className={cn(
            "font-bold text-center",
            variant === "primary" ? "text-2xl" : "text-xl"
          )}
        >
          {toPercent(data.financial.roi, i18n.language)}
        </p>
      </div>
    </div>
  );
};
